import styles from "./index.module.css";
import Spin from "../spin";
import Button from "../button";
const Subscribe = ({
  setInputFocus,
  inputFocus,
  inputValue,
  setInputValue,
  inputStatus,
  onSubmit,
}) => {
  return (
    <div className={styles.ctn} data-cursor-size="160px">
      <h3>Become a ZHIYUN Creator</h3>
      {/* <Button size={'big'} className={styles.buttonToSmooth5s} href="https://explore.zhiyun-tech.com/en/club/project/detail/9">
        SMOOTH 5S Creators Wanted{" "}
        <svg
          width="19"
          height="9"
          viewBox="0 0 19 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 4.5H18M18 4.5L14 0.5M18 4.5L14 8.5" stroke="white" />
        </svg>
      </Button> */}
      {inputStatus !== "passed" ? (
        <div
          style={{
            position: "relative",
          }}
        >
          <div
            className={`${styles.inputBox} ${inputFocus ? styles.focus : ""}`}
            tabIndex="1"
          >
            <input
              type="text"
              className={styles.input}
              placeholder="Enter your e-mail address"
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
              value={inputValue}
              onFocus={() => {
                setInputFocus(true);
              }}
              onBlur={() => {
                setInputFocus(false);
              }}
            />

            {inputStatus === "loading" ? (
              <Spin className={styles.spin}></Spin>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={styles.button}
                onClick={(e) => {
                  if (inputStatus === "failed") {
                    onSubmit(e);
                  }
                }}
              >
                <path
                  d="M3.741 1.40762L22.203 11.5616C22.2814 11.6048 22.3468 11.6682 22.3923 11.7452C22.4378 11.8223 22.4618 11.9101 22.4618 11.9996C22.4618 12.0891 22.4378 12.177 22.3923 12.254C22.3468 12.331 22.2814 12.3945 22.203 12.4376L3.741 22.5916C3.66487 22.6335 3.57915 22.6548 3.49227 22.6535C3.4054 22.6521 3.32037 22.6282 3.24558 22.584C3.17078 22.5397 3.1088 22.4768 3.06573 22.4013C3.02267 22.3259 3.00001 22.2405 3 22.1536V1.84562C3.00001 1.75873 3.02267 1.67335 3.06573 1.59789C3.1088 1.52242 3.17078 1.45949 3.24558 1.41527C3.32037 1.37106 3.4054 1.34711 3.49227 1.34576C3.57915 1.34442 3.66487 1.36574 3.741 1.40762ZM5 12.9996V19.6166L18.85 11.9996L5 4.38262V10.9996H10V12.9996H5Z"
                  fill="white"
                />
              </svg>
            )}
          </div>
          <h6 className={styles.info}>
            {inputStatus === "failed" ||
            inputStatus === "passed" ||
            inputStatus === "loading" ? (
              ""
            ) : (
              <>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_353_3243)">
                    <g clip-path="url(#clip1_353_3243)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.3332 7.99935C15.3332 12.0494 12.0499 15.3327 7.99984 15.3327C3.94975 15.3327 0.666504 12.0494 0.666504 7.99935C0.666504 3.94926 3.94975 0.666016 7.99984 0.666016C12.0499 0.666016 15.3332 3.94926 15.3332 7.99935ZM8.99984 11.666C8.99984 11.1137 8.55212 10.666 7.99984 10.666C7.44755 10.666 6.99984 11.1137 6.99984 11.666C6.99984 12.2183 7.44755 12.666 7.99984 12.666C8.55212 12.666 8.99984 12.2183 8.99984 11.666ZM7.99984 3.33268C7.27573 3.33268 6.7003 3.94097 6.74046 4.66396L6.94437 8.33422C6.97549 8.89439 7.4388 9.33268 7.99984 9.33268C8.56087 9.33268 9.02419 8.89439 9.05531 8.33422L9.25921 4.66396C9.29937 3.94098 8.72394 3.33268 7.99984 3.33268Z"
                        fill="#F93920"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_353_3243">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                    <clipPath id="clip1_353_3243">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {inputStatus}
              </>
            )}
          </h6>
        </div>
      ) : (
        <div className={styles.success}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_353_3275)">
              <g clip-path="url(#clip1_353_3275)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.0002 19.1673C15.0628 19.1673 19.1668 15.0633 19.1668 10.0007C19.1668 4.93804 15.0628 0.833984 10.0002 0.833984C4.93755 0.833984 0.833496 4.93804 0.833496 10.0007C0.833496 15.0633 4.93755 19.1673 10.0002 19.1673ZM14.9027 8.186C15.3221 7.63761 15.2175 6.85309 14.6691 6.43374C14.1207 6.01438 13.3362 6.11898 12.9168 6.66737L8.73665 11.7039L6.82024 9.64996C6.39641 9.10503 5.61106 9.00686 5.06613 9.43069C4.52119 9.85453 4.42303 10.6399 4.84686 11.1848L7.75835 14.5182C7.99627 14.8241 8.36263 15.0023 8.75016 15.0007C9.1377 14.9991 9.50258 14.8179 9.73799 14.51L14.9027 8.186Z"
                  fill="#5DC264"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_353_3275">
                <rect width="20" height="20" fill="white" />
              </clipPath>
              <clipPath id="clip1_353_3275">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
          You've successfully subscribed! You will receive a notification e-mail when we launch a new project.
        </div>
      )}

      <a className={styles.href} href="https://explore.zhiyun-tech.com/en/club/index" target="_blank" rel="noreferrer">Get Our Latest Products For Free</a>
    </div>
  );
};

export default Subscribe;
